/**
 * @generated SignedSource<<95d09f226921e3fac2125249569f240d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type Appliances_applianceCreated_Subscription$variables = {};
export type Appliances_applianceCreated_Subscription$data = {
  readonly applianceCreated: {
    readonly assignee: {
      readonly id: string;
      readonly name: string;
    } | null;
    readonly device: {
      readonly lastConnection: string | null;
      readonly lastDisconnection: string | null;
      readonly online: boolean;
    };
    readonly id: string;
    readonly name: string;
    readonly serial: string;
    readonly tags: ReadonlyArray<string>;
  };
};
export type Appliances_applianceCreated_Subscription = {
  response: Appliances_applianceCreated_Subscription$data;
  variables: Appliances_applianceCreated_Subscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serial",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tags",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastConnection",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastDisconnection",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "online",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "assignee",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Appliances_applianceCreated_Subscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "applianceCreated",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "device",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Appliances_applianceCreated_Subscription",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Appliance",
        "kind": "LinkedField",
        "name": "applianceCreated",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Device",
            "kind": "LinkedField",
            "name": "device",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "929e67689d87719a2978e3a6eee5abfe",
    "id": null,
    "metadata": {},
    "name": "Appliances_applianceCreated_Subscription",
    "operationKind": "subscription",
    "text": "subscription Appliances_applianceCreated_Subscription {\n  applianceCreated {\n    id\n    name\n    serial\n    tags\n    device {\n      lastConnection\n      lastDisconnection\n      online\n      id\n    }\n    assignee {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da39fcc80c219020f9f414b093190434";

export default node;
